<template>
  <div
    :class="{
      'mobile-app-dialog-holder': isMobileApp && dialog !== false
    }"
  >
    <DashboardBloodTestForm v-if="$auth.user?.services?.['lab-online'] === 'active'" />
    <DashboardThematicCounsellingForm
      v-for="(tc, index) in thematicCounsellings"
      :key="`thematicCounselling_${index}`"
      v-bind="tc"
    />
    <DashboardVideoCallForm v-if="$auth.user.benefit.active" />
    <DashboardVideoTherapyForm
      v-if="$auth.user.benefit.active && currentMutation.videoCallTherapistAllowed"
    />
    <template v-if="isTallyAvailable">
      <DashboardTallyTestForm
        v-for="tallyForm in tallyFormsAvailable"
        :key="`tally-form_${tallyForm.internalName}`"
        v-bind="tallyForm"
      />
    </template>
    <ErrorModal />
    <ProfileGoPayThankYouDialog />
    <HealthInsuranceProviderBenefitsDialog />
    <InvitationDialog />
    <AccountDeleteDialog />
    <ReleaseNotesCsasModal />
    <ReleaseNotesModal />
    <ExternalLoginRegistration />
    <EvaluationDialog />
    <AccountSettingsMobileDialog />
    <MedicalProcedureDialog />
    <MedicalProcedureTrashDialog />
    <PhoneVerificationDialog />
    <FeedbackForm />
    <NewsletterAgreementDialog />
    <PreventionPersonalizationDialog />
    <PasswordRenewedDialog />
    <SelfReactivated />
  </div>
</template>

<script>
import DashboardThematicCounsellingForm from '@/components/Forms/DashboardThematicCounsellingForm';
import ErrorModal from '@/components/Atoms/ErrorModal';
import ProfileGoPayThankYouDialog from '@/components/Molecules/ProfileGoPayThankYouDialog';
import thematicCounselling from '@/mixins/thematicCounselling';
import dynamicForms from '@/mixins/dynamicForms';
import HealthInsuranceProviderBenefitsDialog from '@/feature/health-insurance-benefits/components/HealthInsuranceProviderBenefitsDialog';
import ReleaseNotesCsasModal from '@/components/Atoms/ReleaseNotesCsasModal';
import ReleaseNotesModal from '@/components/Atoms/ReleaseNotesModal';
import InvitationDialog from '@/components/Molecules/InvitationDialog';
import ExternalLoginRegistration from '@/components/Atoms/ExternalLoginRegistration';
import AccountDeleteDialog from '@/components/Molecules/AccountDeleteDialog';
import EvaluationDialog from '@/components/Atoms/EvaluationDialog';
import AccountSettingsMobileDialog from '@/components/Organisms/profile/AccountSettingsMobileDialog';
import profileDialogs from '@/mixins/profileDialogs';
import MedicalProcedureDialog from '@/components/Molecules/MedicalProcedureDialog';
import MedicalProcedureTrashDialog from '@/components/Atoms/MedicalProcedureTrashDialog';
import PhoneVerificationDialog from '@/components/Molecules/PhoneVerificationDialog';
import { mapGetters } from 'vuex';
import DashboardVideoCallForm from '@/components/Forms/DashboardVideoCallForm';
import DashboardTallyTestForm from '@/components/Forms/DashboardTallyTestForm';
import FeedbackForm from '@/feature/feedback/components/FeedbackForm.vue';
import NewsletterAgreementDialog from '@/components/Molecules/NewsletterAgreementDialog.vue';
import DashboardBloodTestForm from '@/components/Forms/DashboardBloodTestForm.vue';
import PreventionPersonalizationDialog from '@/components/Molecules/PreventionPersonalizationDialog.vue';
import dashboardBoxes from '@/mixins/dashboardBoxes';
import tallyTests from '@/mixins/tallyTests';
import PasswordRenewedDialog from '@/components/Atoms/PasswordRenewedDialog.vue';
import DashboardVideoTherapyForm from '@/components/Forms/DashboardVideoTherapyForm.vue';
import SelfReactivated from '@/components/Dialogs/SelfReactivated.vue';
import userBenefitCurrentMutation from '@/mixins/currentMutation/userBenefitCurrentMutation.js';

export default {
  name: 'DashboardDialogs',
  components: {
    DashboardVideoTherapyForm,
    PreventionPersonalizationDialog,
    DashboardBloodTestForm,
    NewsletterAgreementDialog,
    FeedbackForm,
    DashboardVideoCallForm,
    DashboardTallyTestForm,
    PhoneVerificationDialog,
    MedicalProcedureTrashDialog,
    MedicalProcedureDialog,
    AccountSettingsMobileDialog,
    EvaluationDialog,
    AccountDeleteDialog,
    InvitationDialog,
    ExternalLoginRegistration,
    HealthInsuranceProviderBenefitsDialog,
    ReleaseNotesCsasModal,
    ReleaseNotesModal,
    DashboardThematicCounsellingForm,
    ErrorModal,
    ProfileGoPayThankYouDialog,
    PasswordRenewedDialog,
    SelfReactivated
  },
  mixins: [
    thematicCounselling,
    dynamicForms,
    profileDialogs,
    dashboardBoxes,
    tallyTests,
    userBenefitCurrentMutation
  ],
  computed: {
    ...mapGetters({
      dialog: 'profile/dashboard/dialog'
    }),
    thematicCounsellings() {
      return [
        /* {
          formName: 'onco-prevention',
          stepsBefore: [
            {
              cmp: 'ThematicCounsellingInfoStep',
              buttonsSettings: {
                nextButtonText: 'thematic_counselling.dashboard.onco-prevention.button'
              },
              dialogDataStore: 'profile/thematicCounselling'
            }
          ],
          stepsAfterForm: [
            {
              cmp: 'DashboardFormFinal',
              params: {
                title: this.$t('thematic_counselling.dashboard.final.title'),
                text: this.$t('thematic_counselling.dashboard.final.text'),
                dataCy: 'dashboardFormFinalText'
              }
            }
          ],
          formSentAction() {
            this.gtmPush({ event: 'form_sent_success', 'form.name': this.formName })
            this.$store.dispatch('profile/dashboard/setQuestions')
          }
        } */
      ];
    }
  },
  watch: {
    async $route() {
      await this.checkUrlForDialog();
    }
  },
  async created() {
    await this.checkUrlForDynamicForm();
    await this.checkUrlForDialog();
  }
};
</script>

<style lang="scss" scoped>
.mobile-app-dialog-holder {
  height: 100%;
  width: 100%;
  position: fixed;
  overflow-y: auto;
  top: 0;
  left: 0;
  margin-top: env(safe-area-inset-top);
}
</style>
